import { render, staticRenderFns } from "./SidebarCoupon.vue?vue&type=template&id=6f0e35fc&scoped=true"
import script from "./SidebarCoupon.vue?vue&type=script&lang=js"
export * from "./SidebarCoupon.vue?vue&type=script&lang=js"
import style0 from "./SidebarCoupon.vue?vue&type=style&index=0&id=6f0e35fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e35fc",
  null
  
)

export default component.exports